module.exports = __webpack_public_path__ + "img/256x256.fbfa4a37.png";